const MAX_ODDS_DISPLAY_COUNT = 504; // オッズランキングに表示する最大件数
const MAX_BET_COUNT = 999; // 1つの買い目に対して一度に購入できる最大口数
const BET_PRICE = 100; // 1口 100円

export { BET_PRICE, MAX_BET_COUNT, MAX_ODDS_DISPLAY_COUNT };
